import React from 'react';
import { Route } from 'react-router';

import { LoadableChallengeAwardsPage } from './helpers/loadables';

export default (
  <>
    {/* Challenge Awards  */}
    <Route
      path="/challengeawards(/:group)(/:category)"
      component={LoadableChallengeAwardsPage}
      whiteBackground
    />
  </>
);
